





























































import { computed, defineComponent, onMounted, onUnmounted, ref, set } from "@vue/composition-api";
import { EventPostSearchResult } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import { checkAuthorities, checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import CreatePostButtonController from "@/components/CreatePostButton";
import EmptyContent from "@/components/EmptyContent";
import PageTitle from "@/components/PageTitle";
import EventCancellationModal from "./components/EventCancellationModal";
import EventsList from "./components/EventsList";

export default defineComponent({
  name: "PageEvents",
  components: {
    BasePage,
    PageTitle,
    BaseButton,
    EmptyContent,
    CreatePostButtonController,
    EventsList,
    EventCancellationModal,
  },
  setup() {
    const loading = ref(false);
    const enableScroll = ref(false);
    const eventsSearchResult = ref<EventPostSearchResult | null>(null);
    const canceledPostId = ref<string>("");
    const canceledIsBuyer = ref<boolean>(false);
    const canceledProcessing = ref(false);
    const { authUserStrict, authorities } = useAuthUser();

    const eventsList = computed(() => eventsSearchResult.value?.result ?? []);
    const isCreator = computed(() => checkRole(authUserStrict.value.role ?? "", "creator"));
    const canCreateEvent = computed(() => {
      return checkAuthorities(authorities.value, ["updateMyEvent", "getMyEvent"]);
    });
    const getEvents = async (page: number = 0, replace: boolean = true) => {
      try {
        loading.value = true;
        enableScroll.value = false;
        const requestId = isCreator.value ? { userId: authUserStrict.value.id } : { buyerId: authUserStrict.value.id };
        const responseData = await providers.EventPostProvider.search({
          data: { ...requestId, page, sort: "TIME,ASC" },
        });
        if (!replace && eventsSearchResult.value) {
          responseData.result = [...eventsSearchResult.value.result, ...responseData.result];
        }
        eventsSearchResult.value = responseData;
      } finally {
        loading.value = false;
        enableScroll.value = eventsSearchResult.value?.hasNextPage ?? false;
      }
    };

    const getEventsHandler = () => getEvents();

    const getNextPage = () => {
      const page = (eventsSearchResult.value?.page ?? 0) + 1;
      getEvents(page, false);
    };

    const handleCancelEvent = (postId: string, isBuyer: boolean) => {
      canceledIsBuyer.value = isBuyer;
      canceledPostId.value = postId;
    };

    const keepCancelEvent = () => {
      canceledPostId.value = "";
    };

    const cancelEvent = async () => {
      canceledProcessing.value = true;
      try {
        canceledIsBuyer.value
          ? await providers.ContentPriceProvider.cancelBySubject({
              data: {
                userId: authUserStrict.value.id,
                subject: { subjectId: canceledPostId.value, subjectType: "event" },
              },
            })
          : await providers.EventPostProvider.cancel({ postId: canceledPostId.value });
        set(
          eventsSearchResult.value,
          "result",
          eventsSearchResult.value?.result.filter(event => event.postId !== canceledPostId.value)
        );
      } finally {
        canceledPostId.value = "";
        canceledProcessing.value = false;
      }
    };

    getEventsHandler();

    onMounted(() => {
      emitter.on("CONTENT_FEED_UPDATED", getEventsHandler);
    });

    onUnmounted(() => {
      emitter.off("CONTENT_FEED_UPDATED", getEventsHandler);
    });

    return {
      loading,
      authUserStrict,
      isCreator,
      canceledPostId,
      canceledIsBuyer,
      canceledProcessing,
      eventsList,
      enableScroll,
      getNextPage,
      handleCancelEvent,
      keepCancelEvent,
      cancelEvent,
      canCreateEvent,
    };
  },
});
